import { Button, Typography } from '@mui/material';

import { mfaColors } from './styles';

const MFA_SETUP_GUIDE_URL = 'https://www.candormedical.com/education/multi-factor-authentication-guide';

export const AuthenticatorSetupGuideLink = () => {
  return (
    <Typography variant="body2">
      Having trouble?{' '}
      <Button
        component="a"
        href={MFA_SETUP_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="text"
        sx={{
          p: 0,
          minWidth: 'auto',
          textTransform: 'none',
          verticalAlign: 'baseline',
          color: mfaColors.primary,
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        View our authenticator setup guide
      </Button>
    </Typography>
  );
};
